<template>
	<vs-row type="flex">
		<vs-col
			vs-type="flex"
			vs-w="8"
			class="sm:p-2 p-4"
		>
			<vx-card>
				<div class="flex">
					<vs-button
						color="primary"
						size="large"
						type="flat"
						icon="icon-arrow-left"
						icon-pack="feather"
						@click="$router.go(-1)"
					></vs-button>
					<h4 class="mt-3">
						Új ügylet
					</h4>
				</div>

				<!-- <router-link to="/forms/form-validation">VeeValidate</router-link> -->

				<div class="mt-5">
					<form-wizard
						id="transaction-wizard"
						ref="wizard"
						color="rgba(var(--vs-primary), 1)"
						errorColor="rgba(var(--vs-danger), 1)"
						:title="null"
						:subtitle="null"
						finishButtonText="Mentés"
						nextButtonText="Tovább"
						backButtonText="Vissza"
					>
						<tab-content
							title="Megrendelő"
							class="mb-5"
							icon="feather icon-user"
							:before-change="validateStep1"
						>

							<vs-row>
								<vx-card title="">
									<div class="flex">
										<h4 class="mt-3 mb-5">
											Megrendelő

										</h4>
										<div class="rounded-lg cursor-pointer items-center justify-center right-button">
											<vs-button
												color="primary"
												size="large"
												type="filled"
												@click="nextStep()"
											>Tovább</vs-button>
										</div>
									</div>

									<vs-row>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="12"
											class="p-2"
										>

											<customer-suggestions
												v-if="filterData"
												ref="customerSearch"
												:data="filterData"
												background-overlay
												class="w-full mb-8"
												inputClassses="w-full"
												icon="SearchIcon"
												placeholder="Keresés..."
												@selected="selected"
											>

												<!-- <template v-slot:group="{ group_name }">
									<p class="font-semibold text-primary">{{ group_name | title }}</p>
								</template> -->

												<template v-slot:customers="{ suggestion }">
													<div class="flex items-end leading-none py-1">
														<feather-icon
															icon="UserIcon"
															svgClasses="h-5 w-5"
															class="mr-4"
														/>
														<span class="mt-1">
															{{ suggestion.displayName }} <br> <small>{{ suggestion.fullAddress }}</small>
														</span>
													</div>
												</template>

												<!-- No Items Slot
										<template v-slot:noResult="{ suggestion_list }">
											<div
												class="flex items-center"
												v-if="1==2"
											>
												<feather-icon
													icon="InfoIcon"
													svgClasses="h-5 w-5"
													class="mr-4"
												/>
												<span>Nem található megrendelő! {{ suggestion_list }}</span>
											</div>
										</template> -->
											</customer-suggestions>

											<span class="text-danger">{{ errors.customerSelect }}</span>

										</vs-col>
										<!-- <vs-col v-if="currentTransaction.customer.displayName">
									<h5 for="">Megrendelő</h5>
									<div class="user-bio">
										<p>{{ currentTransaction.customer.displayName }}</p>
										<p>{{ currentTransaction.customer.fullAddress }}</p>
										<p>{{ currentTransaction.customer.email }}</p>
										<p>{{ currentTransaction.customer.phone }}</p>
									</div>
								</vs-col> -->
									</vs-row>
									<vs-row>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="12"
											class="p-2"
										>
											<label for="">Kiválasztott megrendelő felülírása</label>
											<vs-switch v-model="currentTransaction.updateCustomer" />
										</vs-col>
									</vs-row>
									<vs-row>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="6"
											class="p-2"
										>
											<vs-input
												label-placeholder="Cégnév"
												ref="customerName"
												v-model="currentTransaction.customer.name"
												class="w-full mt-4"
												name="name"
												v-on:keyup.enter="validate"
												autocomplete="none"
											/>
										</vs-col>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="6"
											class="p-2"
										>
											<vs-input
												label-placeholder="Adószám"
												v-model="currentTransaction.customer.vatNumber"
												class="w-full mt-4"
												name="vatNumber"
												v-on:keyup.enter="validate"
												autocomplete="none"
											/>
										</vs-col>
									</vs-row>
									<vs-row>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="6"
											class="p-2"
										>
											<vs-input
												label-placeholder="Vezetéknév"
												v-model="currentTransaction.customer.firstName"
												class="w-full mt-4"
												name="firstName"
												v-validate="'required'"
												v-on:keyup.enter="validate"
												autocomplete="none"
											/>
											<span class="text-danger">{{ errors.first('step-1.firstName') }}</span>
										</vs-col>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="6"
											class="p-2"
										>
											<vs-input
												label-placeholder="Keresztnév"
												v-model="currentTransaction.customer.lastName"
												class="w-full mt-4"
												name="lastName"
												v-validate="'required'"
												v-on:keyup.enter="validate"
												autocomplete="none"
											/>
											<span class="text-danger">{{ errors.first('step-1.lastName') }}</span>
										</vs-col>
									</vs-row>
									<vs-row>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="6"
											class="p-2"
										>
											<vs-input
												label-placeholder="E-mail cím"
												v-model="currentTransaction.customer.email"
												class="w-full mt-4"
												name="email"
												v-validate="'required'"
												v-on:keyup.enter="validate"
												autocomplete="none"
											/>
											<span class="text-danger">{{ errors.first('step-1.email') }}</span>
										</vs-col>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="6"
											class="p-2"
										>
											<vs-input
												label-placeholder="Telefonszám"
												v-model="currentTransaction.customer.phone"
												class="w-full mt-4"
												name="phone"
												v-validate="'required'"
												v-on:keyup.enter="validate"
												autocomplete="none"
											/>
											<span class="text-danger">{{ errors.first('step-1.phone') }}</span>
										</vs-col>
									</vs-row>
									<vs-row>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="4"
											class="p-2"
										>
											<label for="">Irányítószám</label>
											<vs-input
												v-model="currentTransaction.customer.zipCode"
												class="w-full"
												name="zipCode"
												v-validate="'required'"
												v-on:keyup.enter="validate"
												@input="getCityByZipcode('customer')"
												autocomplete="none"
											/>
											<span class="text-danger">{{ errors.first('step-1.zipCode') }}</span>
										</vs-col>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="8"
											class="p-2"
										>
											<!-- City suggest -->
											<label for="">Város</label>
											<vs-input
												v-model="currentTransaction.customer.city"
												class="w-full"
												name="city"
												v-validate="'required'"
												v-on:keyup.enter="validate"
												autocomplete="none"
											/>
											<span class="text-danger">{{ errors.first('step-1.city') }}</span>
										</vs-col>

									</vs-row>
									<vs-row>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="4"
											class="p-2"
										>
											<!-- Street suggest -->
											<label for="">Közterület</label>
											<vue-simple-suggest
												name="street"
												v-validate="'required'"
												class="w-full"
												v-model="currentTransaction.customer.street"
												:list="streets"
												:filter-by-query="true"
												display-attribute="streetName"
												value-attribute="id"
												:min-length="3"
												:debounce="200"
												:controls="{
													selectionUp: [38, 33],
													selectionDown: [40, 34],
													select: [13, 36],
													showList: [40],
													hideList: [27, 35]
												}"
												@select="selectCustomerStreet"
												autocomplete="none"
											>
											</vue-simple-suggest>
											<span
												class="text-danger"
												v-if="submittedForm == 1"
											>{{ errors.first('step-1.street') }}</span>
											<!-- END street suggest -->
										</vs-col>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="4"
											class="p-2"
										>
											<label for="">Közterület jellege</label>
											<vue-simple-suggest
												name="streetType"
												v-validate="'required'"
												class="w-full"
												v-model="currentTransaction.customer.streetType"
												:list="streetTypes"
												:filter-by-query="true"
												display-attribute="streetType"
												value-attribute="id"
												:min-length="3"
												:debounce="200"
												:controls="{
													selectionUp: [38, 33],
													selectionDown: [40, 34],
													select: [13, 36],
													showList: [40],
													hideList: [27, 35]
												}"
												autocomplete="none"
											>
											</vue-simple-suggest>
											<span
												class="text-danger"
												v-if="submittedForm == 1"
											>{{ errors.first('step-1.streetType') }}</span>
										</vs-col>
										<vs-col
											vs-justify="left"
											vs-align="left"
											vs-w="4"
											class="p-2"
										>
											<vs-input
												name="houseNumber"
												v-validate="'required'"
												label="Házszám"
												v-model="currentTransaction.customer.houseNumber"
												class="w-full"
												v-on:keyup.enter="validate"
												autocomplete="none"
											/>
											<span class="text-danger">{{ errors.first('step-1.houseNumber') }}</span>
										</vs-col>
									</vs-row>

									<vs-divider class="" />

									<vs-row>
										<div v-if="contacts && contacts.length > 0">
											<h5 for="">Ügyintéző</h5>
											<vs-select
												class="w-full"
												v-model="currentTransaction.contactId"
												name="transactionContact"
												v-validate="'required'"
											>
												<vs-select-item
													v-for="(contact) in contacts"
													:key="contact.id"
													:value="contact.id"
													:text="contact.fullNameSite"
												/>
											</vs-select>
										</div>
									</vs-row>

								</vx-card>
							</vs-row>

							<!-- <vs-row v-if="!customerType">
								<vs-col
									vs-w="12"
									vs-type="flex"
									id="transaction-type-select"
								>
									<ul>
										<li
											class="inline-block"
											@click="selectCustomerType('search')"
										>
											<statistics-card-line
												color="primary"
												hideChart
												hideIcon
												class="mb-base"
												icon="SearchIcon"
												statistic="Megrendelő keresése"
											/>
										</li>
										<li
											class="inline-block"
											@click="selectCustomerType('new')"
										>
											<statistics-card-line
												color="primary"
												hideChart
												hideIcon
												class="mb-base"
												icon="PlusIcon"
												statistic="Új megrendelő"
											/>
										</li>
									</ul>

								</vs-col>
							</vs-row> -->

							<!-- tab 1 content -->
							<form
								data-vv-scope="step-1"
								v-on:submit.prevent
								autocomplete="off"
							>

								<vs-row v-if="customerType == 'search'">

									<vx-card title="">
										<div class="flex">
											<vs-button
												color="primary"
												size="large"
												type="flat"
												icon="icon-arrow-left"
												icon-pack="feather"
												@click="selectCustomerType(null)"
											></vs-button>
											<h4 class="mt-3">
												Megrendelő keresése
											</h4>
											<div class="rounded-lg cursor-pointer items-center justify-center right-button">
												<vs-button
													color="primary"
													size="large"
													type="filled"
													@click="nextStep()"
												>Tovább</vs-button>
											</div>
										</div>

									</vx-card>
								</vs-row>

								<div v-if="customerType == 'new'">
									<vx-card title="">

									</vx-card>
								</div>
							</form>
						</tab-content>

						<!-- tab 2 content -->
						<tab-content
							title="Ügyfél adatai"
							class="mb-5"
							icon="feather icon-tag"
							:before-change="validateStep2"
						>
							<form
								data-vv-scope="step-2"
								v-on:submit.prevent
							>
								<div class="vs-row center">
									<vx-card title="">
										<div class="flex">
											<div class="rounded-lg cursor-pointer items-center justify-center right-button">
												<vs-button
													class="mr-5"
													color="primary"
													size="large"
													type="border"
													@click="prevStep()"
												>Vissza</vs-button>
												<vs-button
													color="primary"
													size="large"
													type="filled"
													@click="nextStep()"
												>Tovább</vs-button>
											</div>
										</div>
										<vs-row>
											<div>
												<vs-checkbox v-model="clientIsSame">Ügyfél adatai megegyeznek a megrendelő adataival</vs-checkbox>
											</div>
										</vs-row>
										<div>
											<vs-row>
												<h4 class="mt-3">
													Ügyfél adatai
												</h4>
											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Név"
														ref="clientName"
														v-model="currentTransaction.client.name"
														class="w-full mt-4"
														name="name"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Adószám"
														v-model="currentTransaction.client.vatNumber"
														class="w-full mt-4"
														name="vatNumber"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
												</vs-col>
											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Vezetéknév"
														v-model="currentTransaction.client.firstName"
														class="w-full mt-4"
														name="firstName"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
													<span class="text-danger">{{ errors.first('step-1.firstName') }}</span>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Keresztnév"
														v-model="currentTransaction.client.lastName"
														class="w-full mt-4"
														name="lastName"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
													<span class="text-danger">{{ errors.first('step-1.lastName') }}</span>
												</vs-col>
											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="E-mail cím"
														v-model="currentTransaction.client.email"
														class="w-full mt-4"
														name="email"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
													<span class="text-danger">{{ errors.first('step-1.email') }}</span>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Telefonszám"
														v-model="currentTransaction.client.phone"
														class="w-full mt-4"
														name="phone"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
													<span class="text-danger">{{ errors.first('step-1.phone') }}</span>
												</vs-col>
											</vs-row>
										</div>
									</vx-card>
								</div>
							</form>
						</tab-content>

						<!-- tab 2 content -->
						<tab-content
							title="Számlafizető adatai"
							class="mb-5"
							icon="feather icon-tag"
							:before-change="validateStep3"
						>
							<form
								data-vv-scope="step-3"
								v-on:submit.prevent
							>
								<div class="vs-row center">
									<vx-card title="">
										<vs-row>
											<div>
												<vs-checkbox v-model="billingIsSameCustomer">Számlafizető adatai megegyeznek a megrendelő adataival</vs-checkbox>
											</div>
										</vs-row>
										<vs-row>
											<div>
												<vs-checkbox v-model="billingIsSameClient">Számlafizető adatai megegyeznek az ügyfél adataival</vs-checkbox>
											</div>
										</vs-row>
										<div class="flex">
											<div class="rounded-lg cursor-pointer items-center justify-center right-button">
												<vs-button
													class="mr-5"
													color="primary"
													size="large"
													type="border"
													@click="prevStep()"
												>Vissza</vs-button>
												<vs-button
													color="primary"
													size="large"
													type="filled"
													@click="nextStep()"
												>Tovább</vs-button>
											</div>
										</div>
										<div>
											<vs-row>
												<h4 class="mt-3">
													Számlafizető adatai
												</h4>
											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Cégnév"
														ref="customerName"
														v-model="currentTransaction.billing.name"
														class="w-full mt-4"
														name="name"
														autocomplete="none"
													/>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Adószám"
														v-model="currentTransaction.billing.vatNumber"
														class="w-full mt-4"
														name="vatNumber"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
												</vs-col>
											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="E-mail cím"
														v-model="currentTransaction.billing.email"
														class="w-full mt-4"
														name="email"
														autocomplete="none"
													/>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="6"
													class="p-2"
												>
													<vs-input
														label-placeholder="Telefonszám"
														v-model="currentTransaction.billing.phone"
														class="w-full mt-4"
														name="phone"
														autocomplete="none"
													/>
												</vs-col>
											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<label for="">Irányítószám</label>
													<vs-input
														v-model="currentTransaction.billing.zipCode"
														class="w-full"
														name="zipCode"
														v-on:keyup.enter="validate"
														@input="getCityByZipcode('customer')"
														autocomplete="none"
													/>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="8"
													class="p-2"
												>
													<!-- City suggest -->
													<label for="">Város</label>
													<vs-input
														v-model="currentTransaction.billing.city"
														class="w-full"
														name="city"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
												</vs-col>

											</vs-row>
											<vs-row>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<!-- Street suggest -->
													<label for="">Közterület</label>
													<vue-simple-suggest
														name="street"
														class="w-full"
														v-model="currentTransaction.billing.street"
														:list="streets"
														:filter-by-query="true"
														display-attribute="streetName"
														value-attribute="id"
														:min-length="3"
														:debounce="200"
														:controls="{
													selectionUp: [38, 33],
													selectionDown: [40, 34],
													select: [13, 36],
													showList: [40],
													hideList: [27, 35]
												}"
														@select="selectCustomerStreet"
														autocomplete="none"
													>
													</vue-simple-suggest>
													<!-- END street suggest -->
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<label for="">Közterület jellege</label>
													<vue-simple-suggest
														name="streetType"
														class="w-full"
														v-model="currentTransaction.billing.streetType"
														:list="streetTypes"
														:filter-by-query="true"
														display-attribute="streetType"
														value-attribute="id"
														:min-length="3"
														:debounce="200"
														:controls="{
													selectionUp: [38, 33],
													selectionDown: [40, 34],
													select: [13, 36],
													showList: [40],
													hideList: [27, 35]
												}"
														autocomplete="none"
													>
													</vue-simple-suggest>
												</vs-col>
												<vs-col
													vs-justify="left"
													vs-align="left"
													vs-w="4"
													class="p-2"
												>
													<vs-input
														name="houseNumber"
														label="Házszám"
														v-model="currentTransaction.billing.houseNumber"
														class="w-full"
														v-on:keyup.enter="validate"
														autocomplete="none"
													/>
												</vs-col>
											</vs-row>
										</div>
									</vx-card>
								</div>
							</form>
						</tab-content>

						<!-- tab 3 content -->
						<tab-content
							title="Ügylet típusa"
							class="mb-5"
							icon="feather icon-tag"
							:before-change="validateStep4"
						>
							<form
								data-vv-scope="step-3"
								v-on:submit.prevent
							>
								<vx-card title="">
									<div class="flex">
										<div class="rounded-lg cursor-pointer items-center justify-center right-button">
											<vs-button
												class="mr-5"
												color="primary"
												size="large"
												type="border"
												@click="prevStep()"
											>Vissza</vs-button>
											<vs-button
												color="primary"
												size="large"
												type="filled"
												@click="nextStep()"
											>Tovább</vs-button>
										</div>
									</div>
									<div class="vs-row center mt-10">
										<vs-row v-if="!selectedType || selectedType.children.length < 1 ">
											<vs-col
												vs-w="12"
												vs-type="flex"
												id="transaction-type-select"
											>
												<ul>
													<li
														class="inline-block"
														v-for="type in orderedTransactionTypes"
														v-bind:key="type.id"
														@click="selectType(type)"
													>
														<transaction-type-card
															:color="type.id == typeId ? 'primary' : 'default'"
															hideChart
															hideIcon
															class="mb-base"
															:class="{active: type.id == typeId}"
															:statisticTitle="type.name"
															icon="icon-arrow-left"
															icon-pack="feather"
														/>
													</li>
												</ul>
											</vs-col>
										</vs-row>

										<vs-row v-if="selectedType && selectedType.children && selectedType.children.length > 0">
											<div class="flex">
												<vs-button
													color="primary"
													size="large"
													type="flat"
													icon="icon-arrow-left"
													icon-pack="feather"
													@click="selectedType = null"
												>Vissza a főtípusokhoz</vs-button>

											</div>
											<vs-col
												vs-w="12"
												vs-type="flex"
												id="transaction-type-select"
											>
												<h4 class="ml-10 mt-2">{{ selectedType.name }}</h4>
											</vs-col>
											<vs-col
												vs-w="12"
												vs-type="flex"
												id="transaction-type-select"
											>
												<ul>
													<li
														class="inline-block"
														v-for="childType in selectedType.children"
														v-bind:key="childType.id"
														@click="selectSubType(childType)"
													>
														<transaction-type-card
															:color="childType.id == typeId ? 'primary' : 'default'"
															hideChart
															hideIcon
															class="mb-base"
															:class="{active: childType.id == typeId}"
															:statisticTitle="childType.name"
															icon="icon-arrow-left"
															icon-pack="feather"
														/>
													</li>
												</ul>
											</vs-col>
										</vs-row>
									</div>
								</vx-card>
							</form>
						</tab-content>

						<!-- tab 4 content -->
						<tab-content
							title="Ingatlan adatai"
							class="mb-5"
							icon="feather icon-home"
							:before-change="validateStep5"
						>
							<form
								data-vv-scope="step-5"
								v-on:submit.prevent
							>
								<vx-card title="">
									<div class="flex">
										<div class="rounded-lg cursor-pointer items-center justify-center right-button">
											<vs-button
												class="mr-5"
												color="primary"
												size="large"
												type="border"
												@click="prevStep()"
											>Vissza</vs-button>
											<vs-button
												color="primary"
												size="large"
												type="filled"
												@click="nextStep()"
											>Mentés</vs-button>
										</div>
									</div>
									<div class="vs-row mt-10">
										<vs-row>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="6"
												class="p-2"
											>
												<label for="">Irányítószám</label>
												<vs-input
													v-model="currentTransaction.property.zipCode"
													class="w-full"
													name="propertyZipCode"
													v-on:keyup.enter="validate"
													@input="getCityByZipcode('property')"
													autocomplete="none"
												/>

											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="6"
												class="p-2"
											>
												<!-- City suggest -->
												<label for="">Város</label>
												<vs-input
													v-model="currentTransaction.property.city"
													class="w-full"
													name="propertyCity"
													v-validate="'required'"
													v-on:keyup.enter="validate"
													autocomplete="none"
													@change="checkPropertyExists"
												/>
												<span class="text-danger">{{ errors.first('step-5.propertyCity') }}</span>
												<!-- END city suggest -->

											</vs-col>
										</vs-row>
										<vs-row>

											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="4"
												class="p-2"
											>
												<!-- Street suggest -->
												<label for="">Közterület</label>
												<vue-simple-suggest
													name="propertyStreet"
													v-validate="'required'"
													class="w-full"
													v-model="currentTransaction.property.street"
													:list="streets"
													:filter-by-query="true"
													display-attribute="streetName"
													value-attribute="id"
													:min-length="3"
													:debounce="200"
													:controls="{
													selectionUp: [38, 33],
													selectionDown: [40, 34],
													select: [13, 36],
													showList: [40],
													hideList: [27, 35]
												}"
													@select="selectStreet"
												>
												</vue-simple-suggest>
												<span
													class="text-danger"
													v-if="submittedForm == 4"
												>{{ errors.first('step-5.propertyStreet') }}</span>
												<!-- END street suggest -->
											</vs-col>

											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="2"
												class="p-2"
											>
												<label for="">Közterület jellege</label>
												<vue-simple-suggest
													name="propertyStreetType"
													v-validate="'required'"
													class="w-full"
													v-model="currentTransaction.property.streetType"
													:list="streetTypes"
													:filter-by-query="true"
													display-attribute="streetType"
													value-attribute="id"
													:min-length="3"
													:debounce="200"
													:controls="{
													selectionUp: [38, 33],
													selectionDown: [40, 34],
													select: [13, 36],
													showList: [40],
													hideList: [27, 35]
												}"
												>
												</vue-simple-suggest>
												<span
													class="text-danger"
													v-if="submittedForm == 4"
												>{{ errors.first('step-5.propertyStreetType') }}</span>

											</vs-col>

											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="2"
												class="p-2"
											>
												<label for="">Házszám</label>
												<vs-input
													v-model="currentTransaction.property.houseNumber"
													class="w-full"
													name="propertyHouseNumber"
													v-validate="'required'"
												/>
												<span class="text-danger">{{ errors.first('step-5.propertyHouseNumber') }}</span>
											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="4"
												class="p-2"
											>
												<label for="">HRSZ</label>
												<vs-input
													v-model="currentTransaction.property.parcelNumber"
													class="w-full"
													name="property_house_number"
													@change="checkPropertyExists"
												/>
											</vs-col>
										</vs-row>

										<vs-row v-if="propertyExists">
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="12"
												class="p-2">
												<feather-icon 
													icon="AlertCircleIcon" 
													svgClasses="stroke-current text-warning" />
													<strong> A megadott település és HRSZ alapján már található ingatlan a rendszerben.</strong>
											</vs-col>
										</vs-row>

										<vs-divider class="" />
										<vs-row>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="4"
												class="p-2"
											>
												<label for="">Megrendelés dátuma</label>
												<div>
													<vs-button
														type="border"
														size="medium"
														icon-pack="feather"
														icon="icon-minus"
														color="grey"
														class="date-button"
														@click.stop="dayMinus"
														style="display:inline-block; padding: 0 !important;"
													></vs-button>
													<datepicker
														placeholder="Válasszon dátumot"
														format="yyyy-MM-dd"
														style="display:inline-block;"
														v-model="currentTransaction.orderDate"
													></datepicker>
													<vs-button
														type="border"
														size="medium"
														icon-pack="feather"
														icon="icon-plus"
														color="grey"
														class="date-button"
														@click.stop="dayPlus"
														style="display:inline-block; padding: 0 !important;"
													></vs-button>
												</div>
											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="3"
												class="p-2"
											>
												<label for="">Megrendelői ügyszám</label>
												<vs-input
													v-model="currentTransaction.transactionNumber"
													class="w-full"
													name="transactionNumber"
												/>
											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="3"
												class="p-2"
											>
												<label for="">Feladat kód</label>
												<vs-input
													v-model="currentTransaction.taskCode"
													class="w-full"
													name="taskCode"
												/>
											</vs-col>
										</vs-row>
										<vs-row>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="4"
												class="p-2"
											>
												<label for="">Díj</label>
												<vs-input
													v-model="currentTransaction.price"
													class="w-full"
													name="taskCode"
												/>
											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="4"
												class="p-2"
											>
												<label for="">Számla sorszám</label>
												<vs-input
													v-model="currentTransaction.invoiceNumber"
													class="w-full"
													name="taskCode"
												/>
											</vs-col>
										</vs-row>
										<vs-divider class="" />
										<vs-row>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="12"
												class="p-2"
											>
												<h4>Értesítendő személy(ek)</h4>
											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="6"
												class="p-2"
											>
												<label for="">Név</label>
												<vs-input
													v-model="currentTransaction.notified.name"
													class="w-full"
													name="notifiedName"
													v-on:keyup.enter="validate"
													autocomplete="none"
												/>

											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="6"
												class="p-2"
											>
												<label for="">Telefonszám</label>
												<vs-input
													v-model="currentTransaction.notified.phone"
													class="w-full"
													name="notifiedPhone"
													v-on:keyup.enter="validate"
													autocomplete="none"
												/>
											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="6"
												class="p-2"
											>
												<label for="">Név</label>
												<vs-input
													v-model="currentTransaction.notified2.name"
													class="w-full"
													name="notifiedName"
													v-on:keyup.enter="validate"
													autocomplete="none"
												/>

											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="6"
												class="p-2"
											>
												<label for="">Telefonszám</label>
												<vs-input
													v-model="currentTransaction.notified2.phone"
													class="w-full"
													name="notifiedPhone"
													v-on:keyup.enter="validate"
													autocomplete="none"
												/>
											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="6"
												class="p-2"
											>
												<label for="">Név</label>
												<vs-input
													v-model="currentTransaction.notified3.name"
													class="w-full"
													name="notifiedName"
													v-on:keyup.enter="validate"
													autocomplete="none"
												/>

											</vs-col>
											<vs-col
												vs-justify="left"
												vs-align="left"
												vs-w="6"
												class="p-2"
											>
												<label for="">Telefonszám</label>
												<vs-input
													v-model="currentTransaction.notified3.phone"
													class="w-full"
													name="notifiedPhone"
													v-on:keyup.enter="validate"
													autocomplete="none"
												/>
											</vs-col>
										</vs-row>
									</div>
								</vx-card>
							</form>
						</tab-content>
					</form-wizard>
				</div>
			</vx-card>
		</vs-col>
		<vs-col
			vs-justify="left"
			vs-align="left"
			vs-w="4"
			class="sm:p-2 p-4"
		>
			<div>
				<vx-card title="Megrendelő">
					<div class="user-bio">
						<p>{{ currentTransaction.customer.displayName }}</p>
						<p>{{ currentTransaction.customer.fullAddress }}</p>
						<p>{{ currentTransaction.customer.email }}</p>
						<p>{{ currentTransaction.customer.phone }}</p>
					</div>
				</vx-card>
			</div>
			<div class="mt-5">
				<vx-card title="Ügyfél">
					<div class="user-bio">
						<p>{{ currentTransaction.client.displayName }}</p>
						<p>{{ currentTransaction.client.fullAddress }}</p>
						<p>{{ currentTransaction.client.email }}</p>
						<p>{{ currentTransaction.client.phone }}</p>
					</div>
				</vx-card>
			</div>
			<div class="mt-5">
				<vx-card title="Számlafizető">
					<div class="user-bio">
						<p>{{ currentTransaction.billing.displayName }}</p>
						<p>{{ currentTransaction.billing.fullAddress }}</p>
						<p>{{ currentTransaction.billing.email }}</p>
						<p>{{ currentTransaction.billing.phone }}</p>
					</div>
				</vx-card>
			</div>
			<div class="mt-5">
				<vx-card title="Ügylet típusa">
					<div class="user-bio">
						<p>{{ currentTransaction.type.name }}</p>
					</div>
				</vx-card>
			</div>
			<div class="mt-5">
				<vx-card title="Ingatlan">
					<template slot="actions">
						<div class="inline-flex">
							<vs-button
								class="mr-2"
								type="filled"
								size="small"
								icon-pack="feather"
								icon="icon-refresh-cw"
								color="danger"
								:disabled="!mapRendered"
								@click="getCoord()"
							></vs-button>
							<vs-button
								type="filled"
								size="small"
								icon-pack="feather"
								icon="icon-maximize"
								class="mr-2"
								color="danger"
								:disabled="!mapRendered"
								@click="mapFullScreen=true"
							></vs-button>
						</div>
					</template>

					<div class="user-bio">
						<p>{{ this.fullAddress }}</p>
						<vs-tabs
							alignment="fixed"
							v-if="showMap"
						>
							<vs-tab label="Térkép">
								<div>
									<GmapMap
										v-if="showMap"
										:center.sync="center"
										:zoom="15"
										map-type-id="terrain"
										style="width: 100%; height: 400px"
									>
										<GmapMarker
											:position="center"
											:clickable="true"
										/>
									</GmapMap>
								</div>
							</vs-tab>
							<vs-tab label="Utcanézet">
								<div>
									<gmap-street-view-panorama
										class="pano"
										v-if="showMap"
										:position="center"
										:pov="pov"
										:zoom="1"
										style="width: 100%; height: 400px"
									>
									</gmap-street-view-panorama>
								</div>
							</vs-tab>

						</vs-tabs>

						<!-- Map full screen popup -->
						<vs-popup
							fullscreen
							:title="this.fullAddress"
							:active.sync="mapFullScreen"
						>
							<vs-button
								id="print-button"
								class="mb-1"
								size="small"
								icon-pack="feather"
								icon="icon icon-file"
								@click="printMap"
							>Nyomtatás</vs-button>
							<GmapMap
								:center.sync="center"
								:zoom="15"
								map-type-id="terrain"
								style="width: 100%; height: 100%"
							>
								<GmapMarker
									:position="center"
									:clickable="true"
								/>
							</GmapMap>
						</vs-popup>
						<!-- END Map full screen popup -->

					</div>
				</vx-card>
			</div>

		</vs-col>
	</vs-row>

</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import VueSimpleSuggest from 'vue-simple-suggest';
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import CustomerSuggestions from '@/views/transactions/components/CustomerSuggestions.vue';
import TransactionTypeCard from '@/views/transactions/components/TransactionTypeCard.vue';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import _ from 'lodash';
// For custom error message
import { Validator } from 'vee-validate';

const dict = {
	custom: {
		customerSelect: {
			required: 'Megrendelő kiválasztsa kötelező',
		},
		propertyCounty: {
			required: 'Kötelező mező',
		},
		propertyCity: {
			required: 'Kötelező mező',
		},
		propertyZipCode: {
			required: 'Kötelező mező',
		},
		propertyStreetType: {
			required: 'Kötelező mező',
		},
		propertyStreet: {
			required: 'Kötelező mező',
		},
		propertyHouseNumber: {
			required: 'Kötelező mező',
		},
		propertyParcelNumber: {
			required: 'Kötelező mező',
		},
		type: {
			required: 'Kötelező mező',
		},
		name: {
			required: 'Név megadása kötelező',
		},
		vatNumber: {
			required: 'Adószám megadása kötelező',
		},
		firstName: {
			required: 'Vezetéknév megadása kötelező',
		},
		lastName: {
			required: 'Keresztnév megadása kötelező',
		},
		email: {
			required: 'E-mail cím megadása kötelező',
		},
		phone: {
			required: 'Telefonszám megadása kötelező',
		},
		zipCode: {
			required: 'Irányítószám megadása kötelező',
		},
		county: {
			required: 'Megye megadása kötelező',
		},
		city: {
			required: 'Város megadása kötelező',
		},
		street: {
			required: 'Közterület megadása kötelező',
		},
		streetType: {
			required: 'Közterület megadása kötelező',
		},
		houseNumber: {
			required: 'Házszám megadása kötelező',
		},
	}
};

// register custom messages
Validator.localize('en', dict);

export default {
	components: {
		FormWizard,
		TabContent,
		StatisticsCardLine,
		TransactionTypeCard,
		VueSimpleSuggest,
		CustomerSuggestions,
		Datepicker
	},
	data() {
		this.selectedCustomer = null;
		return {
			filterData: {
				customers: {
					key: '',
					data: '',
				}
			},
			selectedType: null,
			streets: [],
			center: { lat: 0, lng: 0 },
			showMap: false,
			pov: {
				heading: 180,
				pitch: 0
			},
			pano: null,
			sites: null,
			contacts: null,
			mapFullScreen: false,
			mapRendered: false,
			transactionTypes: null,
			allTransactionType: null,
			mainCustomers: null,
			submittedForm: null,
			customerType: null,
			propertyExists: false,
			counties: [
				{ text: 'Bács-Kiskun' },
				{ text: 'Baranya' },
				{ text: 'Békés' },
				{ text: 'Borsod-Abaúj-Zemplén' },
				{ text: 'Csongrád' },
				{ text: 'Fejér' },
				{ text: 'Győr-Moson-Sopron' },
				{ text: 'Hajdú-Bihar' },
				{ text: 'Heves' },
				{ text: 'Jász-Nagykun-Szolnok' },
				{ text: 'Komárom-Esztergom' },
				{ text: 'Nógrád' },
				{ text: 'Pest' },
				{ text: 'Somogy' },
				{ text: 'Szabolcs-Szatmár-Bereg' },
				{ text: 'Tolna' },
				{ text: 'Vas' },
				{ text: 'Veszprém' },
				{ text: 'Zala' },
			],
			billingIsSameCustomer: false,
			billingIsSameClient: false,
			clientIsSame: false,
			streetTypes: [],
			currentTransaction: {
				customer: {
					zipCode: '',
					city: '',
				},
				client: {
					zipCode: '',
					city: '',
					lastName: '',
					firstName: '',
				},
				notified: {
					name: '',
					phone: '',
					email: ''
				},
				notified2: {
					name: '',
					phone: '',
					email: ''
				},
				notified3: {
					name: '',
					phone: '',
					email: ''
				},
				updateCustomer: false,
				orderDate: moment(new Date()).format('YYYY-MM-DD'),
				type: '',
				property: {
					zipCode: '',
					county: '',
					city: '',
					street: '',
					streetType: '',
					houseNumber: '',
					parcelNumber: '',
				},
				transactionNumber: '',
				price: '',
				invoiceNumber: '',
				billing: {
					name: '',
					vatNumber: '',
					zipCode: null,
					city: '',
					area: '',
					street: '',
					streetType: '',
					houseNumber: '',
				}
			},
			typeId: '',
			mainTypeId: '',
		}
	},
	methods: {
		//Test
		nextStep() {
			this.$refs.wizard.nextTab();
		},
		prevStep() {
			this.$refs.wizard.prevTab();
		},
		// test end
		cities() {
			return this.cities
		},
		selectCustomerType(customerType) {
			this.customerType = customerType
			this.currentTransaction.customer = {}
			setTimeout(() => {
				if (customerType == 'search') {
					this.$refs.customerSearch.$el.children[0].children[0].children[0].children[0].focus()
				} else if (customerType == 'new') {
					this.$refs.customerName.$el.children[0].children[0].focus()
				}

			}, 200);
		},
		selected(item) {
			this.currentTransaction.customer.id = item.customers.id
			this.currentTransaction.customer = item.customers
			this.selectedCustomer = Object.assign({}, item.customers)

			this.$http.get("/api/customers/get/" + item.customers.id)
				.then((response) => {
					this.sites = response.data.data.sites
					if (this.sites.length > 0) {
						this.currentTransaction.siteId = this.sites[0].id
					}
					this.contacts = response.data.data.contacts
					if (this.contacts.length > 0) {
						this.currentTransaction.contactId = this.contacts[0].id
					}
				})
				.catch((error) => {
					console.log(error.response.message);
				})
		},
		getContacts() {
			this.contacts = this.contacts.filter((contact) => {
				return contact.site.id == this.currentTransaction.siteId
			})

		},
		selectType(type) {
			this.typeId = type.id
			this.mainTypeId = type.id
			this.selectedType = type

			this.generateTransactionNumber(this.mainTypeId);

			if(this.selectedType.children.length < 1) {
				this.nextStep()
			}

			// if(this.selectedType.id == 1) {
			// 	this.currentTransaction.transactionNumber = this.currentTransaction.customer.transactioncodePrefix.residental + '/'
			// } else if(this.selectedType.id == 2) {
			// 	this.currentTransaction.transactionNumber = this.currentTransaction.customer.transactioncodePrefix.company + '/'
			// }
			// console.log(this.currentTransaction);
			// console.log(this.currentTransaction.customer.transactioncodePrefix);
			// console.log(this.currentTransaction.transactionNumber);
		},
		selectSubType(type) {
			console.log(type);
			this.nextStep()
			this.typeId = type.id
		},
		generateTransactionNumber(mainTypeId) {
			this.$http.post("/api/transactions/generate-transaction-number", {mainTypeId: mainTypeId, customer: this.currentTransaction.customer})
				.then((response) => {
					console.log(response);
					this.currentTransaction.transactionNumber = response.data.transactionNumber
					
				}).catch((error) => {
					console.log(error)
					this.showError(error)
				})
		},
		validateStep1() {
			console.log('validateStep1')
			this.submittedForm = 1;
			return new Promise((resolve, reject) => {
				this.$validator.validateAll('step-1').then(result => {
					if (this.customerType == 'search' && !this.selectedCustomer) {
						this.errors.customerSelect = 'Megrendelő kiválasztása kötelező'
						reject("correct all values");
					}
					if (result) {
						resolve(true)
					} else {
						reject("correct all values");
					}
				})
			})
		},
		validateStep2() {
			console.log('validateStep2')
			this.submittedForm = 2;
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-2").then(result => {
					if (result) {
						resolve(true)
					} else {
						reject("correct all values");
					}
				})
			})
		},
		validateStep3() {
			console.log('validateStep3')
			this.submittedForm = 3;
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-3").then(result => {
					if (result) {
						resolve(true)
					} else {
						reject("correct all values");
					}
				})
			})
		},
		validateStep4() {
			console.log('validateStep4')
			this.submittedForm = 4;
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-4").then(result => {
					if (result) {
						this.currentTransaction.notified.phone = this.currentTransaction.client.phone
						this.currentTransaction.notified.name = this.currentTransaction.client.firstName + ' ' + this.currentTransaction.client.lastName
						resolve(true)
					} else {
						reject("correct all values");
					}
				})
			})
		},
		validateStep5() {
			console.log('validateStep5')
			this.submittedForm = 5;
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("step-5").then(result => {
					if (result) {
						this.save()
						resolve(true)
					} else {
						reject("correct all values");
					}
				})
			})
		},
		save() {
			this.$vs.loading()
			this.$http.post("/api/transactions/create", this.currentTransaction)
				.then(() => {
					this.$vs.loading.close()
					this.$router.push('/ugyletek')
					this.customer = {}
					this.customerModal = false
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres mentés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
				}).catch((error) => {
					this.showError(error.response.data)
				})
		},
		fetchTransactionTypes() {
			this.$http.get('/api/transaction-types/list/')
				.then((response) => {
					this.transactionTypes = response.data.data
				})
				.catch((error) => { console.log(error) })
		},
		fetchAllTransactionTypes() {
			this.$http.get('/api/transaction-types/list?type=all')
				.then((response) => {
					this.allTransactionType = response.data.data
				})
				.catch((error) => { console.log(error) })
		},
		fetchCustomers() {
			this.$http.get('/api/customers/list/')
				.then((response) => {
					let customersArray = response.data.data;
					this.filterData.customers = {}
					this.filterData.customers.key = 'displayName'
					this.filterData.customers.keys = ['displayName', 'phone', 'name', 'firstName', 'lastName', 'vatNumber', 'email', 'fullAddress']
					this.filterData.customers.data = customersArray
					this.mainCustomers = response.data.data.filter(customer => {
						return customer.parentId == null;
					})
				})
				.catch((error) => { console.log(error) })
		},
		getCoord() {
			let address = this.currentTransaction.property.zipCode + ' ' + this.currentTransaction.property.city + ' ' + this.currentTransaction.property.street + ' ' + this.currentTransaction.property.streetType + ' ' + this.currentTransaction.property.houseNumber
			if (this.currentTransaction.property.city !== '' &&
				this.currentTransaction.property.street !== '' &&
				this.currentTransaction.property.streetType !== '' &&
				this.currentTransaction.property.houseNumber !== '') {

				this.$http.post('/api/transactions/getCoord/', { address: encodeURIComponent(address) })
					.then((response) => {
						this.center.lat = response.data.lat
						this.center.lng = response.data.lng
						this.showMap = true
					})
					.catch((error) => { console.log(error) })

			}
		},
		printMap() {
			window.print()
		},
		// getCities() {
		// 	this.$http.post('/api/transactions/getCities')
		// 		.then((response) => {
		// 			this.cities = response.data.data
		// 			console.log(this.cities);
		// 		})
		// 		.catch((error) => { console.log(error) })
		// },
		selectCustomerCounty(county) {
			this.currentTransaction.customer.city = ''
			this.currentTransaction.customer.zipCode = ''
			this.currentTransaction.customer.street = ''
			this.$http.post('/api/transactions/getCities', { county: county.text })
				.then((response) => {
					this.cities = response.data.data
				})
				.catch((error) => { console.log(error) })
		},
		selectCustomerCity(city) {
			this.currentTransaction.customer.zipCode = city.zipCode
			this.currentTransaction.customer.street = ''
			if (city.hasSub) {
				this.$http.post('/api/transactions/getStreets', { cityId: city.id })
					.then((response) => {
						this.streets = response.data.data
					})
					.catch((error) => { console.log(error) })
			} else {
				this.currentTransaction.customer.streetType = ''
				this.streets = null
			}
		},
		selectCustomerStreet(street) {
			this.currentTransaction.customer.selectedStreetId = street.id
			this.currentTransaction.customer.zipCode = street.zipCode
			this.currentTransaction.customer.streetName = street.streetName
			this.currentTransaction.customer.streetType = street.streetType

			this.$http.post('/api/transactions/getStreetTypes', { streetName: street.streetName, zipCode: street.zipCode })
				.then((response) => {
					this.streetTypes = response.data.data
				})
				.catch((error) => { console.log(error) })
		},
		selectClientStreet(street) {
			this.currentTransaction.client.selectedStreetId = street.id
			this.currentTransaction.client.zipCode = street.zipCode
			this.currentTransaction.client.streetName = street.streetName
			this.currentTransaction.client.streetType = street.streetType

			this.$http.post('/api/transactions/getStreetTypes', { streetName: street.streetName, zipCode: street.zipCode })
				.then((response) => {
					this.streetTypes = response.data.data
				})
				.catch((error) => { console.log(error) })
		},
		selectCounty(county) {
			this.currentTransaction.property.city = ''
			this.currentTransaction.property.zipCode = ''
			this.currentTransaction.property.street = ''
			this.$http.post('/api/transactions/getCities', { county: county.text })
				.then((response) => {
					this.cities = response.data.data
				})
				.catch((error) => { console.log(error) })
		},
		selectCity(city) {
			this.currentTransaction.property.zipCode = city.zipCode
			this.currentTransaction.property.street = ''
			if (city.hasSub) {
				this.$http.post('/api/transactions/getStreets', { cityId: city.id })
					.then((response) => {
						this.streets = response.data.data
					})
					.catch((error) => { console.log(error) })
			} else {
				this.currentTransaction.property.streetType = ''
				this.streets = null
			}
		},
		selectStreet(street) {
			this.currentTransaction.property.selectedStreetId = street.id
			this.currentTransaction.property.zipCode = street.zipCode
			this.currentTransaction.property.streetName = street.streetName
			this.currentTransaction.property.streetType = street.streetType

			this.$http.post('/api/transactions/getStreetTypes', { streetName: street.streetName, zipCode: street.zipCode })
				.then((response) => {
					this.streetTypes = response.data.data
				})
				.catch((error) => { console.log(error) })
		},
		getCityByZipcode(type) {
			if (this.currentTransaction[type].zipCode.length == 4) {
				this.$http.post('/api/transactions/getCityByZipcode', { zipCode: this.currentTransaction[type].zipCode })
					.then((response) => {
						if (response.data.data) {
							this.currentTransaction[type].city = response.data.data.city
							this.currentTransaction[type].county = response.data.data.county
							// if (type == 'customer') {
							// } else if (type == 'property') {
							// this.currentTransaction.property.city = response.data.data.city
							// }

							this.$http.post('/api/transactions/getStreets', { zipCode: this.currentTransaction[type].zipCode })
								.then((response) => {
									this.streets = response.data.data
									console.log(this.streets);
								})
								.catch((error) => { console.log(error) })

							this.checkPropertyExists()
						} else {
							this.currentTransaction.customer.city = ''
						}
					})
					.catch((error) => { console.log(error) })
			}
		},
		compareObjects(oldVal, newVal) {
			if (oldVal.length !== newVal.length) {
				return false;
			}

			return newVal.filter(function (a) {
				return oldVal.map(function (b) { return b.id; }).indexOf(a.id) === -1;
			}).length === 0 ? true : false;
		},
		dayMinus() {
			let date = new Date(this.currentTransaction.orderDate);
			date.setDate(date.getDate() - 1);
			this.currentTransaction.orderDate = date
		},
		dayPlus() {
			let date = new Date(this.currentTransaction.orderDate);
			date.setDate(date.getDate() + 1);
			this.currentTransaction.orderDate = date
		},
		showError(errors) {
			var errorText = ''
			for (var error in errors) {
				errorText += errors[error][0] + '<br>'
			}

			this.$vs.loading.close()
			this.$vs.notify({
				time: 8000,
				title: 'Hiba',
				text: 'Elnézést! A rendszer hibába ütközött. <br> --- <br>' + errorText,
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'danger',
				position: 'bottom-center'
			})
		},
		checkPropertyExists() {
			this.$http.post('/api/transactions/checkPropertyExists', { 
									city: this.currentTransaction.property.city,
									parcelNumber: this.currentTransaction.property.parcelNumber
								})
								.then((response) => {
									this.propertyExists = response.data.exists
									console.log(response.data);
								})
								.catch((error) => { console.log(error) })
		}
	},
	watch: {
		currentTransaction: {
			handler(newVal, oldVal) {
				// if (newVal.clientIsSame) {
				// 	console.log(newVal.clientIsSame);
				// }
				let isSame = _.isEqual(newVal.customer, this.selectedCustomer);
				if (!isSame) {
					this.currentTransaction.selectedCustomerId = null
				} else {
					this.currentTransaction.selectedCustomerId = this.selectedCustomer.id
				}
			},
			deep: true,
		},
		typeId() {
			let type = this.allTransactionType.find(e => e.id == this.typeId)
			this.currentTransaction.type = type
		},
		fullAddress() {
			if (this.currentTransaction.property.city !== '' &&
				this.currentTransaction.property.street !== '' &&
				this.currentTransaction.property.streetType !== '' &&
				this.currentTransaction.property.houseNumber !== '' &&
				!this.mapRendered) {
				setTimeout(() => {
					this.mapRendered = true
					this.getCoord()

				}, 1500);
			}
		},
		billingIsSameCustomer() {
			console.log('customer')
			if (this.billingIsSameCustomer) {
				this.billingIsSameClient = false
				setTimeout(() => {
					this.currentTransaction.billing = _.cloneDeep(this.currentTransaction.customer)
					delete this.currentTransaction.billing.id
				}, 200);
			} else {
				this.currentTransaction.billing.displayName = ''
				this.currentTransaction.billing.fullAddress = ''
				this.currentTransaction.billing.name = ''
				this.currentTransaction.billing.email = ''
				this.currentTransaction.billing.phone = ''
				this.currentTransaction.billing.vatNumber = ''
				this.currentTransaction.billing.zipCode = ''
				this.currentTransaction.billing.city = ''
				this.currentTransaction.billing.area = ''
				this.currentTransaction.billing.street = ''
				this.currentTransaction.billing.streetType = ''
				this.currentTransaction.billing.houseNumber = ''
			}
		},
		billingIsSameClient() {
			console.log('client')
			if (this.billingIsSameClient) {
				this.billingIsSameCustomer = false
				setTimeout(() => {
					this.currentTransaction.billing = _.cloneDeep(this.currentTransaction.client)
					delete this.currentTransaction.billing.id
				}, 200);
			} else {
				this.currentTransaction.billing.displayName = ''
				this.currentTransaction.billing.fullAddress = ''
				this.currentTransaction.billing.name = ''
				this.currentTransaction.billing.email = ''
				this.currentTransaction.billing.phone = ''
				this.currentTransaction.billing.vatNumber = ''
				this.currentTransaction.billing.zipCode = ''
				this.currentTransaction.billing.city = ''
				this.currentTransaction.billing.area = ''
				this.currentTransaction.billing.street = ''
				this.currentTransaction.billing.streetType = ''
				this.currentTransaction.billing.houseNumber = ''
			}
		},
		clientIsSame() {
			console.log('clientIsSame');
			if (this.clientIsSame) {
				this.currentTransaction.client = _.cloneDeep(this.currentTransaction.customer)
				console.log(this.currentTransaction.client);
				delete this.currentTransaction.client.id
			} else {
				this.currentTransaction.client.displayName = ''
				this.currentTransaction.client.fullAddress = ''
				this.currentTransaction.client.name = ''
				this.currentTransaction.client.email = ''
				this.currentTransaction.client.phone = ''
				this.currentTransaction.client.vatNumber = ''
				this.currentTransaction.client.zipCode = ''
				this.currentTransaction.client.city = ''
				this.currentTransaction.client.area = ''
				this.currentTransaction.client.street = ''
				this.currentTransaction.client.streetType = ''
				this.currentTransaction.client.houseNumber = ''
			}
		}
	},
	computed: {
		fullAddress() {
			let address = this.currentTransaction.property.zipCode + ' ' + this.currentTransaction.property.city + ' ' + this.currentTransaction.property.street + ' ' + this.currentTransaction.property.streetType + ' ' + this.currentTransaction.property.houseNumber
			return address
		},
		orderedTransactionTypes: function () {
			return _.orderBy(this.transactionTypes, 'count', 'desc')
		}
	},
	created() {
		this.fetchAllTransactionTypes()
		this.fetchTransactionTypes()
		this.fetchCustomers()
		// this.getCities()
	},
	mounted() {

	}

}
</script>
<style>
.search-location {
	display: block;
	width: 60vw;
	margin: 0 auto;
	margin-top: 5vw;
	font-size: 20px;
	font-weight: 400;
	outline: none;
	height: 30px;
	line-height: 30px;
	text-align: center;
	border-radius: 10px;
}
@media print {
	.con-vs-popup .vs-popup {
		max-width: 100%;
	}
	.vs-popup--close {
		display: none;
	}
	.vs-popup {
		box-shadow: none;
	}
	#print-button {
		display: none;
	}
}
</style>